import { AfterViewInit, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LINE_OF_BUSINESS_ENUM, LoggedInUserInformationService } from '@ptl/account-management';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';

@Component({
    selector: 'app-producer-telesales-content-filter',
    templateUrl: './producer-telesales-content-filter.component.html',
    styleUrls: ['./producer-telesales-content-filter.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ProducerTelesalesContentFilterComponent implements OnInit {

  @Input() lob: LINE_OF_BUSINESS_ENUM;

  isLoaded: boolean = false;
  isTelesales: boolean = false;
  isAuthoring: boolean = false;

  constructor(
    private authoringMode: AuthoringModeService,
    private loggedInUserService: LoggedInUserInformationService
  ) {

  }

  async ngOnInit() {
    this.isAuthoring = this.authoringMode.getAuthoringMode();
    this.isTelesales = await this.loggedInUserService.isTelesales(this.lob);
    this.isLoaded = true;
  }
}
